<template>
    <UiModal :open="status_show_popup" @close="status_show_popup = false">
      <div v-if="on_step == 'step_init'" class="px-5 pt-5 pb-4">
        <h4 class="tac mb-4">
          <span class="ml-3">
            {{lg('',{
              en: 'One last step...',
              zh: '最后一步...',
            })}}
          </span>
          <br>
          <span>
            {{lg('',{
              en: 'Add funding',
              zh: '充值',
            })}}
          </span>
        </h4>
        <div class="tac mb-4 small">
          
          {{lg('',{
            en: `You're about to buy`,
            zh: '你将购买',
          })}}
          <b class="c">{{cfg.nft_name}}</b>. 

          <span v-html="lg({
            key: '',
            template_arr: [
              {
                key: 'token_name',
                val: ($store.state.web3.account_wallet.find(coin => coin.id == cfg.token_type) || {}).name,
              },
            ],
          },{
            en: `There isn't enough \{\{token_name\}\} in your wallet. Add funds now to finish!`,
            zh: '\{\{token_name\}\} 余额不足. 先去充值钱包吧？',
          })">

          </span>
          
        </div>
        <div class="tac mb-4">
          <span class="ui-wallet-icon">
            <!-- icon -->
          </span>
        </div>
        <div class="tac mt-4 pt-3">
          <button
            @click="on_step = 'step_qrcode' "
            :class="['btn btn-primary btn-round']"
            style="min-width: 120px;"
            >
            {{lg('',{
              en: 'Add Funds',
              zh: '充值',
            })}}
          </button>
        </div>
      </div>
      <div v-if="on_step == 'step_qrcode'" class="p-5">
        <h5 class="tac mb-4 b">
          {{lg('',{
            en: 'Receive BNB, JGN, CAKE',
            zh: '可接受 BNB, JGN, CAKE',
          })}}
        </h5>
        <div class="tac mb-4 d-flex justify-content-center">
          <CpQrcode 
            :text="$store.state.web3.account" 
            style="width: 200px;height: 200px;overflow: hidden;"
          />
        </div>
        <div class="tac small">
          {{lg('',{
            en: 'Scan QR code or copy the address below',
            zh: '扫描二维码或复制下方地址',
          })}}
          <br>
          <span class="c">
            <span>
              {{$store.state.web3.account | shortAddress}}
            </span>
            <b 
              v-clipboard:copy="$store.state.web3.account" 
              v-clipboard:success="onCopied" 
              class="ml-2 cp"
              >
              {{lg('copy')}}
            </b>
          </span>
        </div>
      </div>
    </UiModal>
</template>

<script>
// cfg
export default {
  name: 'popupAddFund',
  components: {},
  props: {
    cfg: {
      default: {
        token_type: 'eth',
        nft_name: '',
        on_step: 'step_init',
      },
    }
  },
  data() {
    return {
      on_step: 'step_init',
      status_show_popup: false,
    }
  },
  computed: {},
  watch: {
    cfg(){
      this.showPopup()
    },
  },
  methods: {
    onCopied(){
      this.$toasted.show(this.lg('copied'))
    },
    showPopup(){
      let v = this
      v.status_show_popup = true
      if(v.cfg.on_step){
        v.on_step = v.cfg.on_step
      }else{
        v.on_step = 'step_init'
      }
    },
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>